module.exports = __webpack_public_path__ + "static/media/WU_STEPS_recipient_inactive.ea59157f.svg";